"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (insertBlock, blockList, block) {
    var insertHandler = function (blockToInsert) {
        return blockList.replaceBlock(blockToInsert, block);
    };
    return insertBlock(insertHandler);
});
